import { styled } from '@mui/material/styles'
import { Box, Typography, FormControlLabel } from '@mui/material'
import { imageryBg, imageryBgPlain } from '../../../../assets/images'
import { LEGEND_COLOR_MAP_V2 } from '../../../../constants'
import { exportToPPT_tableCss } from '../../../../util'
import { MEDIA } from '../../../../constants'

const RIGHT_CONTENT = '220px'
const SEARCH_ICON = '50px'

export const OuterWrapper = styled(Box)(`
    width: 100%;
    padding: 0;

    .list .level2 {
        width: 100%;
    }

    &.showExpandAllCTA_false {
        .brandImageryRow.header{
            width: calc(100% - ${RIGHT_CONTENT});
            margin-right:0;
        }
        .brandImageryRow.footer{
            width: calc(100% - ${RIGHT_CONTENT});
            margin-right:0;
        }
        .GraphScaleWrapper > div {
            background-size:calc(100% - ${RIGHT_CONTENT});
        }
        .GraphScaleWrapper .brandImageryRow .graphRowDetails {
            display:none;
        }
        .GraphScaleWrapper .brandImageryRow .list {
            width: calc(100% - ${RIGHT_CONTENT});
        }
    }

    @media (max-width: ${MEDIA.lg}) {
        padding:20px 20px 40px 20px;
    }
`)

export const InnerWrapper = styled(Box)(
  (props) => `
    position:relative;
`
)

export const GraphOuterWrapper = styled(Box)(
  (props) => `
    display: flex;
    flex-direction: column;
    width: 100%;
    // position: relative;
    align-items: end;
    background: #fff;

    ${
      props.hasTabs &&
      `        marginLeft: '-12px';
        width: 'calc(100% + 24px)';
    `
    }
`
)

export const MuiButtonWrap = styled(Box)(`
    position:relative;
`)

export const GraphInnerWrapper = styled(Box)(`
    display:flex;
    width:100%;
    position: relative;

    &.sticky{
        position: sticky;
        top: 0;
        left: 0;
        z-index: 50;
    }
`)

export const Graph = styled(Box)(
  (props) => `
    position: relative;
    display: flex;
    margin-left: auto;
    flex-direction: column;
    width: 100%;
    align-items: end;
    z-index: 1;
    background-image: url('${props.simulator === 'yes' ? imageryBg : imageryBgPlain}'); // SULAMAN
    background-position: ${RIGHT_CONTENT} 0;
    background-repeat-x: no-repeat;
    background-size: calc(100% - (${RIGHT_CONTENT}));
`
)

export const GraphInfoWrapper = styled(Box)(`
    width: calc(100% - ${RIGHT_CONTENT});
    margin-right:${SEARCH_ICON};
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    > span {
        min-width:300px;
        font-size: 12px;
        line-height: calc(14 / 12);
        &:first-of-type {
            display: flex;
            align-items: center;
        }
        &:last-child {
            display: flex;
            align-items: center;
            flex-direction: row-reverse;
            >img{
                transform: rotateY(180deg);
                filter: hue-rotate(-245deg) brightness(1.5);
            }
        }
        >img{
            padding-right: 10px;
        }
    }
`)

export const GridHeaderWrapper = styled(Box)(`
    display:flex;
    width:100%;
    position:relative;
    z-index:1;
`)

export const SliderOuterWrapper = styled(Box)(`
	display: flex;
	width: 100%;
	justify-content: flex-start;
    position:relative;
    border-bottom: 1px #fff solid;
    padding:2px 0;
    & .textOuterWrapper {
        width:100%;
        display:flex;
        flex-direction:column;
    }
    & .textWrapper {
        height:12px;
        width:100%;
        display:block;
        font-size:12px !important;
    }
    & .textWrapper .text {
        position: relative;
        width:100%;
        display:inline;
        font-size:12px !important;
    }
`)

export const ClientLogo = styled(Box)(`
    width: 230px;
    margin-left: -230px;
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right:10px;

    & img {
        max-height:16px;
    }
`)

export const FilterOuterWrap = styled(Box)(`
    padding: 10px 30px 0;
	display: flex;
	width: 100%;
	margin-top:-40px;

	.filterButton {
		color: #095BBD;
		font-size: 14px;
		font-weight: 600;
		background: none;
		padding: 0;
		min-width: auto;
		margin-bottom:10px;
	}
`)

export const FilterExpanded = styled(Box)(`
	display: flex;
	width: 100%;
	flex-direction: column;
    align-items: flex-start;
	padding-bottom: 15px;
	& label span {
		line-height: 15px !important;
		font-size: 14px !important;
	}
	& .selectAll {
		margin-left:-16px;
		color:#095BBD;
	}
	& svg {
		margin-left:10px;
	}
`)

export const FilterCollapsed = styled(Box)(`
	display: flex;
	width: 100%;

	& svg {
		margin-left:10px;
		transform: rotate(180deg);
	}
`)

export const FilterHeading = styled(Typography)(`
	display: flex;
	width: 100%;
	color: #000;
	font-size: 14px;
	font-weight: 600;
`)

export const FilterSelectAll = styled(FormControlLabel)(`
  & .MuiTypography-root {
    font-size: 14px;
    font-weight: 400;
	color: #095BBD;
  }
  & .MuiCheckbox-root{
    padding: 0;
    margin: 3px 10px auto 12px;
  }
`)

export const FilterCheckboxWrap = styled(Box)(`
	display: flex;
	padding: 5px;
	flex-wrap: wrap;
	width: 100%;
	& label {
		width: 180px;
		align-items: flex-start;
		padding-bottom: 10px !important;
	}
	& label span {
		padding-top:0 !important;
		white-space: break-spaces !important;
	}
`)

export const FilterButtonsWrap = styled(Box)(`
	display: flex;
	width: 100%;
	justify-content: end;
	padding: 15px 0 30px 0;
`)
